import { IArtist } from './artist';
import { IGenre } from './genre';

export enum TrackType {
  AudioOnly = 'Audio',
  VideoAndAudio = 'VideoAndAudio',
}

export interface ITrack {
  id?: number;
  albumId?: string;
  isrc: string;
  trackNumber: number;
  title: string;
  version: string;
  displayArtist: string;
  discOrSideNumber: number;
  artists?: IArtist[];
  writersComposers?: IWriterComposer[];
  publishers?: IPublisher[];
  duration?: number;
  copyrightYear?: number | null;
  copyrightLine?: string;
  phonographicCopyrightYear?: number;
  phonographicCopyrightLine?: string;
  genre?: IGenre;
  audioLanguage?: string;
  trackType?: TrackType | null;
}

export interface IWriterComposer {
  name: string;
  role: string;
}
export interface IPublisher {
  name: string;
  performing_Rights_Organization: string;
}

export interface ITrackLookupResult {
  productId?: string | null;
  trackId?: string | null;
  productType?: string | null;
  trackTitle?: string | null;
  displayArtist?: string | null;
  isrc?: string | null;
  productTitle?: string | null;
  upc?: string | null;
  condition?: string | null;
  source?: string | null;
  discNumber?: number | null;
  trackNumber?: number | null;
  version?: string | null;
  duration?: number | null;
  trackType?: TrackType | null;
  copyrightYear?: number | null;
  copyrightLine?: string | null;
  phonographicCopyrightYear?: number | null;
  phonographicCopyrightLine?: string | null;
  genre?: IGenre | null;
  audioLanguage?: string | null;
  artists?: ITrackLookupArtist[] | null;
  contributors?: IWriterComposer[] | null;
  publishers?: IPublisher[] | null;
}

export interface ITrackLookupResponse {
  results: ITrackLookupResult[];
}

export interface ITrackLookupArtist {
  name: string;
  performerRole?: string | null;
  sequence?: number;
}
